import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookSquare, faGoogle, faTwitterSquare, faTwitch, faLinkedin,
  faYoutubeSquare, faInstagram, faFacebookMessenger,
} from '@fortawesome/free-brands-svg-icons';
import {
  faLongArrowAltRight, faTimes,
  faGem, faHandHoldingUsd, faEye, faEyeSlash,
  faUserCircle, faCamera, faLock, faCheck,
  faCaretDown, faSearch, faCalendarDay, faHandshake,
  faStar, faMapMarkerAlt, faShareAlt, faPencilAlt, faCircle,
  faTrashAlt, faClone, faMinusSquare, faTag, faNewspaper,
  faLaptopCode, faTv, faPodcast, faThumbtack, faCalendarWeek,
  faLink, faMale, faFemale, faUsers, faGlobe, faMinusCircle,
  faAngleDown, faInfoCircle, faPhone, faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

import Toasted from 'vue-toasted';

import PortalVue from 'portal-vue';

import vSelect from 'vue-select';

import VueTypedJs from 'vue-typed-js';

import SocialSharing from 'vue-social-sharing';

import Meta from 'vue-meta';

import VueAnalytics from 'vue-analytics';

import App from './App.vue';
import router from './router';
import store from './store';
import ToolTip from './components/utils/ToolTip.vue';
import ContactUser from './components/utils/ContactUser.vue';
import ShareUrl from './components/utils/ShareUrl.vue';
import './registerServiceWorker';

library.add(
  faFacebookSquare, faGoogle, faTwitterSquare, faTwitch, faLinkedin,
  faYoutubeSquare, faInstagram, faFacebookMessenger,
  faLongArrowAltRight, faTimes,
  faGem, faHandHoldingUsd, faEye, faEyeSlash,
  faUserCircle, faCamera, faLock, faCheck,
  faCaretDown, faSearch, faCalendarDay, faHandshake,
  faStar, faMapMarkerAlt, faShareAlt, faPencilAlt, faCircle,
  faTrashAlt, faClone, faMinusSquare, faTag, faNewspaper,
  faLaptopCode, faTv, faPodcast, faThumbtack, faCalendarWeek,
  faLink, faMale, faFemale, faUsers, faGlobe, faMinusCircle,
  faAngleDown, faInfoCircle, faPhone, faEnvelope,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('tooltip', ToolTip);
Vue.component('contact-user', ContactUser);
Vue.component('share-url', ShareUrl);

Vue.use(Toasted, {
  duration: 3000,
  position: 'top-center',
  // iconPack: 'fontawesome', // TODO some open issues in github project needs to be merged in..
});

Vue.use(PortalVue);
Vue.use(VueTypedJs);
Vue.use(SocialSharing);
Vue.use(Meta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
  commands: {
    headerClick() {
      this.$ga.event('header', 'click', 'header', 1);
    },
    profileClick() {
      this.$ga.event('header', 'click', 'profile', 1);
    },
    eventMapScroll() {
      this.$ga.event('event', 'click', 'mapScroll', 1);
    },
    eventTeamPopup() {
      this.$ga.event('event', 'click', 'teamPopup', 1);
    },
    eventCard() {
      this.$ga.event('event', 'click', 'card', 1);
    },
    eventSharePopupTop() {
      this.$ga.event('event', 'click', 'sharePopupTop', 1);
    },
    eventSharePopupBottom() {
      this.$ga.event('event', 'click', 'sharePopupBottom', 1);
    },
    eventContactUserPopupTop() {
      this.$ga.event('event', 'click', 'contactUserPopupTop', 1);
    },
    eventContactUserPopupBottom() {
      this.$ga.event('event', 'click', 'contactUserPopupBottom', 1);
    },
  },
});

Vue.component('v-select', vSelect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
